import { PropsWithChildren } from 'react';

import { Icons, mergeSx } from '@cast/design-system';

import { ExpandedTable } from './ExpandedTable';

import { SearchableTable, SearchableTableProps } from '@cast/shared-search-ui';

export const NetworkCostTable = ({
  children,
  showDetails,
  ...props
}: PropsWithChildren<SearchableTableProps> & { showDetails?: boolean }) => {
  const sx = mergeSx(
    {
      marginTop: 10,

      '& .DS-Table-CellWrapper-expander svg': {
        height: '16px',
        width: '16px',
      },
    },
    props.sx
  );

  return (
    <SearchableTable
      maxHeight="80vh"
      {...props}
      getExpandedPanel={(row, rowState) => (
        <ExpandedTable
          data={row}
          showDetails={showDetails}
          columnModels={rowState.tableApi.columnsInfo.columnModels}
        />
      )}
      expanderIcon={(_, rowState) =>
        rowState?.isExpanded ? Icons.CaretUp : Icons.CaretDown
      }
      onRowClick={(_event, rowState) => {
        if (rowState.level === 0) {
          rowState.tableApi.toggleIsRowExpanded(rowState.row);
        }
      }}
      sx={sx}
    >
      {children}
    </SearchableTable>
  );
};
